import { isHTMLElement } from "./chunk-3XANSPY5.mjs"; // src/scroll.ts

function isScrollParent(el) {
  var win = el.ownerDocument.defaultView || window;

  var _win$getComputedStyle = win.getComputedStyle(el),
      overflow = _win$getComputedStyle.overflow,
      overflowX = _win$getComputedStyle.overflowX,
      overflowY = _win$getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getParent(el) {
  if (el.localName === "html") return el;
  return el.assignedSlot || el.parentElement || el.ownerDocument.documentElement;
}

function getScrollParent(el) {
  if (["html", "body", "#document"].includes(el.localName)) {
    return el.ownerDocument.body;
  }

  if (isHTMLElement(el) && isScrollParent(el)) {
    return el;
  }

  return getScrollParent(getParent(el));
}

export { getScrollParent };